var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-book-additional-hours p-4" }, [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-8 offset-md-2" },
        [
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: { to: "/my-reservations" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.menu.my_reservations")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: { to: "/reservation/" + _vm.order.id }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.my_reservations.reservation_detail")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("message.professional_tip.title")) +
              "\n    "
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-4" }, [
      _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
        _c("section", [
          _c("div", [
            _c("label", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t("message.professional_tip.select_amount")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row no-gutters py-2" },
            _vm._l(_vm.tips, function(tip, index) {
              return _c("div", { key: index, staticClass: "col-4 p-2" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn badge badge-pill badge-light text-pro-number text-center w-100",
                    class: [
                      { "active-button": _vm.selectTip === tip },
                      "pillTip"
                    ],
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.assignTip("select", tip)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n              ฿" +
                        _vm._s(_vm._f("prettyNumber")(tip)) +
                        "\n            "
                    )
                  ]
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "py-2 text-secondary" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.professional_tip.custom_amount")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.inputTip,
                  expression: "inputTip",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                inputmode: "numeric",
                pattern: "[0-9]*",
                min: "20",
                max: _vm.maxAmount,
                placeholder: _vm.$t(
                  "message.professional_tip.custom_amount_hint"
                )
              },
              domProps: { value: _vm.inputTip },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputTip = _vm._n($event.target.value)
                  },
                  function($event) {
                    return _vm.assignTip("input", _vm.inputTip)
                  }
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-2 text-remark" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("message.professional_tip.custom_amount_remark")
                  ) +
                  " " +
                  _vm._s(_vm._f("prettyNumber")(_vm.maxAmount)) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "py-3" }, [
            _c("div", [
              _c("span", [
                _c("i", { staticClass: "fas fa-circle bullet-notification" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("message.professional_tip.remark01")) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", [
                _c("i", { staticClass: "fas fa-circle bullet-notification" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("message.professional_tip.remark02")) +
                    "\n            "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-end" }, [
          _c("div", [
            _c("label", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$t("message.professional_tip.amount")))
            ]),
            _vm._v(" "),
            _vm.totalTip
              ? _c("span", { staticClass: "-status-new text-pro-number" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.totalTip)))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          [
            _c("hr"),
            _vm._v(" "),
            _c("payment-methods", {
              ref: "paymentMethods",
              attrs: {
                displayCreditCardRemark: true,
                displayBankTransfer: false
              },
              on: {
                onSelectedPaymentMethod: _vm.updatePaymentMethod,
                onSelectedCreditCard: _vm.applyUserCreditCard,
                onRequestedSavingTempData: _vm.saveTempData,
                onSuccessQrPayment: _vm.displaySuccessDialog
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pt-2" }, [
          _vm.paymentMethod !== "promptpay"
            ? _c(
                "button",
                {
                  staticClass: "btn btn-info btn-block",
                  attrs: { disabled: _vm.isLoading },
                  on: {
                    click: function($event) {
                      return _vm.submitData()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.isLoading
                          ? _vm.$t("message.button.loading")
                          : _vm.$t("message.button.ok")
                      ) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48888c62", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48888c62","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/GiveProfessionalTip.vue
// module id = 1683
// module chunks = 0